/**
 * PlantApi
 * 1.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "oazapfts/lib/runtime";
import * as QS from "oazapfts/lib/runtime/query";
export const defaults: Oazapfts.Defaults<Oazapfts.CustomHeaders> = {
    headers: {},
    baseUrl: "/",
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {};
export type CorpCatDto = {
    "number": number;
    name: string;
    active: boolean;
    inUse: boolean;
};
export type DataStatus = "success" | "notValid" | "exception" | "error" | "inUse" | "notFound" | "noChange" | "inProgress" | "invalidPage" | "notAuthorized" | "duplicateEntity" | "noContent" | "accepted";
export type ErrorResponse = {
    message: string;
    kind: DataStatus;
    exception?: string | null;
    stackTrace?: string | null;
    exceptionType?: string | null;
    innerException?: string | null;
    validationErrors?: {
        [key: string]: string[];
    } | null;
};
export type DefaultAssignmentDto = {
    equipmentNumber: number;
    employeeNumber: number;
    skillTypeCode: string;
};
export type EmployeeSkillDto = {
    employee: number;
    skillCode: string;
};
export type EquipLookupView = {
    "number": number;
    name: string;
    isActive: boolean;
    line: number;
    workGroup: number;
    allergenLevel: number;
    kpi: number;
    isCritical: boolean;
    taskHeight: number;
    includeInWo: boolean;
    includeInInspect: boolean;
    location: string;
    hasTasks: boolean;
};
export type EquipDto = {
    "number": number;
    name: string;
    model: string;
    serialNumber: string;
    dateManufactured?: string | null;
    dateInstalled?: string | null;
    comments: string;
    assetNumber: string;
    startTaskCalculationDate: string;
    downDay: string;
    datePurchased?: string | null;
    lastDate?: string | null;
    isAsset: boolean;
    nextMaterialNumber: number;
    active: boolean;
    startHours: number;
    lineNumber: number;
    dayNumber: number;
    profitCenter?: number | null;
    manufactureVendorNumber: number;
    location: string;
    reminderToRestartDate?: string | null;
    nextNumberToStoreDeletedTask: number;
    workGroupNumber: number;
    legacyEquipmentNumber: string;
    critical: boolean;
    hasNoTasks: boolean;
    corpEquipNum: string;
    includeInInspections: boolean;
    lastHours: number;
    workpackDayNumber: number;
    eqVerNum: number;
    eqCreatedByUser: number;
    eqCreatedDate?: string | null;
    eqLastUser: number;
    eqLastModifiedDate?: string | null;
    taskVersionNumber: number;
    taskCreatedByUser: number;
    taskCreatedDate?: string | null;
    taskLastUser: number;
    taskLastModifiedDate?: string | null;
    taskPdfName: string;
    manualPdfName: string;
    includeInWo: boolean;
    corporateCategoryNumber: number;
    purchasePrice?: number | null;
    taskCheckOutUser: number;
    taskCheckOutDate?: string | null;
    taskHeight: number;
    mobileGenerateSheet: boolean;
    noTaskForward: boolean;
    corporateReportUse?: number | null;
    corporateLock: boolean;
    isNoDelete: boolean;
};
export type ValidationProblemDetails = {
    "type"?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors: {
        [key: string]: string[];
    };
    [key: string]: any;
};
export type EquipAreaViewDto = {
    name: string;
    isAsset: boolean;
    active: boolean;
    lineNumber: number;
    lineName: string;
    dayNumber: number;
    location: string;
    workGroupNumber: number;
    workGroupName: string;
    changeoverLevel: number;
    critical: boolean;
    hasNoTasks: boolean;
    corpEquipNum: string;
    includeInInspections: boolean;
    workpackDayNumber: number;
    includeInWo: boolean;
    corporateCategoryNumber: number;
    corporateCategoryName: string;
    taskHeight: number;
    mobileGenerateSheet: boolean;
    noTaskForward: boolean;
    corporateReportUse: number;
    corporateLock: boolean;
    isNoDelete: boolean;
    model: string;
    manufactureVendorNumber: number;
    "number": number;
};
export type EquipmentHistoryViewDto = {
    historyDate: string;
    "type": string;
    id: number;
    employee: string;
    status: string;
    hours: number;
    comment: string;
};
export type PdfNameDto = {
    "number": number;
    success: boolean;
};
export type BaseEquipAreaViewDto = {
    name: string;
    isAsset: boolean;
    active: boolean;
    lineNumber: number;
    lineName: string;
    dayNumber: number;
    location: string;
    workGroupNumber: number;
    workGroupName: string;
    changeoverLevel: number;
    critical: boolean;
    hasNoTasks: boolean;
    corpEquipNum: string;
    includeInInspections: boolean;
    workpackDayNumber: number;
    includeInWo: boolean;
    corporateCategoryNumber: number;
    corporateCategoryName: string;
    taskHeight: number;
    mobileGenerateSheet: boolean;
    noTaskForward: boolean;
    corporateReportUse: number;
    corporateLock: boolean;
    isNoDelete: boolean;
    model: string;
    manufactureVendorNumber: number;
};
export type BaseEquipAreaViewDtoEquipDtoImportDto = {
    addedItems: BaseEquipAreaViewDto[];
    updatedItems: EquipDto[];
    deletedItems: number[];
};
export type ImportErrorDto = {
    property: string;
    errors: string[];
    warnings: string[];
};
export type EquipFilter = {
    isAnyFilter: boolean;
    equipName: string;
    groups: number[];
    corpCategories: number[];
    lines: number[];
    includeActive: boolean;
    includeInactive: boolean;
    includeCritical: boolean;
    includeNonCritical: boolean;
    location: string;
    model: string;
    sortAscending: boolean;
    sort: string;
    includeWithTasks: boolean;
    includeWithoutTasks: boolean;
};
export type EquipAreaViewDtoListResultSet = {
    totalResults: number;
    totalPages: number;
    currentPage: number;
    pageSize: number;
    previousUrl?: string | null;
    nextUrl?: string | null;
    filter?: any | null;
    data?: EquipAreaViewDto[] | null;
};
export type EquipFilterListResultSet = {
    totalResults: number;
    totalPages: number;
    currentPage: number;
    pageSize: number;
    previousUrl?: string | null;
    nextUrl?: string | null;
    filter?: any | null;
    data?: EquipFilter[] | null;
};
export type EquipTaskHeightDto = {
    code: number;
    description?: string | null;
    order?: number | null;
    isDefault: boolean;
};
export type EquipLookupSimpleView = {
    "number": number;
    name: string;
};
export type LineDto = {
    name: string;
    location: string;
    dateInstalled?: string | null;
    active: boolean;
    comments: string;
    gmp: boolean;
    "number": number;
};
export type BaseLineDto = {
    name: string;
    location: string;
    dateInstalled?: string | null;
    active: boolean;
    comments: string;
    gmp: boolean;
};
export type BaseLineDtoLineDtoImportDto = {
    addedItems: BaseLineDto[];
    updatedItems: LineDto[];
    deletedItems: number[];
};
export type VendorLookupView = {
    "number": number;
    name: string;
};
export type VendorDto = {
    name: string;
    address1: string;
    address2: string;
    address3: string;
    phone1: string;
    phone2: string;
    fax: string;
    faxAttn: string;
    website: string;
    contact1: string;
    title1: string;
    email1: string;
    contact2: string;
    title2: string;
    email2: string;
    note1: string;
    keywords: string;
    corp: string;
    active: boolean;
    currency: string;
    "number": number;
};
export type VendorDtoListResultSet = {
    totalResults: number;
    totalPages: number;
    currentPage: number;
    pageSize: number;
    previousUrl?: string | null;
    nextUrl?: string | null;
    filter?: any | null;
    data?: VendorDto[] | null;
};
export type BaseVendorDto = {
    name: string;
    address1: string;
    address2: string;
    address3: string;
    phone1: string;
    phone2: string;
    fax: string;
    faxAttn: string;
    website: string;
    contact1: string;
    title1: string;
    email1: string;
    contact2: string;
    title2: string;
    email2: string;
    note1: string;
    keywords: string;
    corp: string;
    active: boolean;
    currency: string;
};
export type BaseVendorDtoListResultSet = {
    totalResults: number;
    totalPages: number;
    currentPage: number;
    pageSize: number;
    previousUrl?: string | null;
    nextUrl?: string | null;
    filter?: any | null;
    data?: BaseVendorDto[] | null;
};
export type WorkGroupDto = {
    name: string;
    active: boolean;
    comment: string;
    changeoverLevel: number;
    defaultAllSelection: boolean;
    "number": number;
    systemCreated: boolean;
};
export type BaseWorkGroupDto = {
    name: string;
    active: boolean;
    comment: string;
    changeoverLevel: number;
    defaultAllSelection: boolean;
};
export type BaseWorkGroupDtoWorkGroupDtoImportDto = {
    addedItems: BaseWorkGroupDto[];
    updatedItems: WorkGroupDto[];
    deletedItems: number[];
};
export function getCorporateCategoryList(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: CorpCatDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/corpcategory", {
        ...opts
    });
}
export function createCorporateCategory(corpCatDto: CorpCatDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: CorpCatDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/corpcategory", oazapfts.json({
        ...opts,
        method: "POST",
        body: corpCatDto
    }));
}
export function getCorporateCategory($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: CorpCatDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/corpcategory/${encodeURIComponent($number)}`, {
        ...opts
    });
}
export function updateCorporateCategory($number: number, corpCatDto: CorpCatDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: CorpCatDto;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/corpcategory/${encodeURIComponent($number)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: corpCatDto
    }));
}
export function deleteCorporateCategory($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/corpcategory/${encodeURIComponent($number)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Get Default Assignments for Equipment/Area
 */
export function getEquipmentDefaultAssignmentList($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: DefaultAssignmentDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipment/${encodeURIComponent($number)}/defaultassignments`, {
        ...opts
    });
}
/**
 * Create/Update/Remove Default Assignments for Equipment/Area
 */
export function createEquipmentDefaultAssignment($number: number, body: EmployeeSkillDto[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: DefaultAssignmentDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipment/${encodeURIComponent($number)}/defaultassignments`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Get Specific Default Assignment (if exists) for Equipment/Area - Equipment/Area Number and Skill Type Code
 */
export function getEquipmentDefaultAssignment($number: number, code: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: DefaultAssignmentDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipment/${encodeURIComponent($number)}/skill/${encodeURIComponent(code)}`, {
        ...opts
    });
}
/**
 * Delete Default Assignment for Equipment/Area and Skill Type Code
 */
export function deleteEquipmentDefaultAssignment($number: number, code: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipment/${encodeURIComponent($number)}/skill/${encodeURIComponent(code)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Number and Name for Equipment/Area for use in most Drop Downs
 */
export function getEquipmentLookupList(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EquipLookupView[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/equipmentlookuplist", {
        ...opts
    });
}
export function getEquipment($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EquipDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipment/${encodeURIComponent($number)}`, {
        ...opts
    });
}
export function updateEquipment($number: number, equipDto: EquipDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EquipDto;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipment/${encodeURIComponent($number)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: equipDto
    }));
}
export function deleteEquipment($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipment/${encodeURIComponent($number)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Equipment/Area Number is provided by the End User. It is not auto generated. 409 error on attempted duplicate.
 */
export function createEquipment(equipDto: EquipDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EquipDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/equipment", oazapfts.json({
        ...opts,
        method: "POST",
        body: equipDto
    }));
}
export function getEquipAreaList(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EquipAreaViewDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/equipment", {
        ...opts
    });
}
/**
 * Sets the Worksheet Tasks for the Equipment/Area due
 */
export function setEquipmentForceDue($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipment/${encodeURIComponent($number)}/forcedue`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Gets 6 months of History for the Equipment/Area History Tab's Table in descending date order
 */
export function getEquipmentHistory($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EquipmentHistoryViewDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipment/${encodeURIComponent($number)}/history`, {
        ...opts
    });
}
/**
 * Get PDF in Stream
 */
export function downloadEquipmentManual($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipment/${encodeURIComponent($number)}/manual/pdf`, {
        ...opts
    });
}
/**
 * Upload PDF to Equipment/Area, New or Replacement PDF. Only one per Equipment/Area-Manual.   multipart/form-data
 */
export function uploadEquipmentManual($number: number, body?: {
    files: Blob[];
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: PdfNameDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipment/${encodeURIComponent($number)}/manual/setpdf`, oazapfts.multipart({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Get PDF in Stream
 */
export function downloadEquipmentWorksheet($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipment/${encodeURIComponent($number)}/worksheet/pdf`, {
        ...opts
    });
}
export function equipmentAreaTemplate(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/equipment/template", {
        ...opts
    });
}
/**
 * Upload PDF to Equipment/Area, New or Replacement PDF. Only one per Equipment/Area-Worksheet.   multipart/form-data
 */
export function uploadWorksheet($number: number, body?: {
    files: Blob[];
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: PdfNameDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipment/${encodeURIComponent($number)}/worksheet/setpdf`, oazapfts.multipart({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Used to bulk import Equipment/Areas.
 */
export function importEquipmentAreas(baseEquipAreaViewDtoEquipDtoImportDto: BaseEquipAreaViewDtoEquipDtoImportDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ImportErrorDto[];
    } | {
        status: 202;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/equipment/importall", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: baseEquipAreaViewDtoEquipDtoImportDto
    }));
}
export function deleteAllEquipmentAreas(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/equipment/all", {
        ...opts,
        method: "DELETE"
    });
}
export function getEquipAreaListForImport(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: BaseEquipAreaViewDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/equipment/importlist", {
        ...opts
    });
}
export function uploadEquipmentAreaImportTemplate(body?: {
    file: Blob;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText("/api/equipment/uploadtemplate", oazapfts.multipart({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * A filter for a specific type of equipment for use in finding items in the equipment list.
 */
export function getEquipmentFilterList(equipFilter: EquipFilter, { page, pageSize }: {
    page?: number;
    pageSize?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EquipAreaViewDtoListResultSet;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipmentfilter${QS.query(QS.explode({
        page,
        pageSize
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: equipFilter
    }));
}
/**
 * A default filter as defined for a specific client.
 */
export function getEquipmentDefaultFilter(name: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EquipFilterListResultSet;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/equipmentfilter/default/${encodeURIComponent(name)}`, {
        ...opts
    });
}
export function getEquipmentTaskHeights(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EquipTaskHeightDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/equipmentareataskheight", {
        ...opts
    });
}
/**
 * Number and Name for Equipment/Area for use in Inspection Detail Drop Downs. There is another endpoint for most Equip/Area lookups.
 */
export function getEquipmentLookupListForInspection(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EquipLookupSimpleView[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/equipmentlookuplistforinspection", {
        ...opts
    });
}
export function getEquipmentLineList(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LineDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/line", {
        ...opts
    });
}
/**
 * Production Line Number is provided by the End User. It is not auto generated. 409 error on attempted duplicate.
 */
export function createEquipmentLine(lineDto: LineDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LineDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/line", oazapfts.json({
        ...opts,
        method: "POST",
        body: lineDto
    }));
}
export function getEquipmentLine($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LineDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/line/${encodeURIComponent($number)}`, {
        ...opts
    });
}
export function updateEquipmentLine($number: number, lineDto: LineDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LineDto;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/line/${encodeURIComponent($number)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: lineDto
    }));
}
export function deleteEquipmentLine($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/line/${encodeURIComponent($number)}`, {
        ...opts,
        method: "DELETE"
    });
}
export function productionLineTemplate(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/line/template", {
        ...opts
    });
}
export function getEquipmentLineForImport(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: BaseLineDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/line/importlist", {
        ...opts
    });
}
/**
 * Used to bulk import product lines.
 */
export function importProductLines(baseLineDtoLineDtoImportDto: BaseLineDtoLineDtoImportDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ImportErrorDto[];
    } | {
        status: 202;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/line/importall", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: baseLineDtoLineDtoImportDto
    }));
}
export function deleteAllEquipmentLines(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/line/all", {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Number and Name for Active Vendors for use in Drop Downs.
 */
export function getVendorLookupList(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: VendorLookupView[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/vendorlookuplist", {
        ...opts
    });
}
/**
 * ** Required Pagination Parameters **
 */
export function getVendorList({ page, pageSize, name, sort, sortAscending }: {
    page?: number;
    pageSize?: number;
    name?: string;
    sort?: string;
    sortAscending?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: VendorDtoListResultSet;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/vendor${QS.query(QS.explode({
        page,
        pageSize,
        name,
        sort,
        sortAscending
    }))}`, {
        ...opts
    });
}
export function createVendor(vendorDto: VendorDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: VendorDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/vendor", oazapfts.json({
        ...opts,
        method: "POST",
        body: vendorDto
    }));
}
export function getVendor($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: VendorDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/vendor/${encodeURIComponent($number)}`, {
        ...opts
    });
}
export function updateVendor($number: number, vendorDto: VendorDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: VendorDto;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/vendor/${encodeURIComponent($number)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: vendorDto
    }));
}
export function deleteVendor($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/vendor/${encodeURIComponent($number)}`, {
        ...opts,
        method: "DELETE"
    });
}
export function deleteAllVendors(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/vendor/all", {
        ...opts,
        method: "DELETE"
    });
}
export function getVendorTemplate(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/vendor/template", {
        ...opts
    });
}
/**
 * Used to bulk import Vendors. NOTE: THIS WILL DELETE ALL EXISTING Vendors.
 */
export function importVendors(body: BaseVendorDto[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: VendorDto[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/vendor/importall", oazapfts.json({
        ...opts,
        method: "PATCH",
        body
    }));
}
/**
 * ** Required Pagination Parameters **
 */
export function getVendorListForImport({ page, pageSize, name }: {
    page?: number;
    pageSize?: number;
    name?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: BaseVendorDtoListResultSet;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/vendor/importlist${QS.query(QS.explode({
        page,
        pageSize,
        name
    }))}`, {
        ...opts
    });
}
export function getWorkGroupList(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: WorkGroupDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/workgroup", {
        ...opts
    });
}
/**
 * Work Group Number is provided by the End User. It is not auto generated. 409 error on attempted duplicate.
 */
export function createWorkGroup(workGroupDto: WorkGroupDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: WorkGroupDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/workgroup", oazapfts.json({
        ...opts,
        method: "POST",
        body: workGroupDto
    }));
}
export function getWorkGroup($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: WorkGroupDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/workgroup/${encodeURIComponent($number)}`, {
        ...opts
    });
}
export function updateWorkGroup($number: number, workGroupDto: WorkGroupDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: WorkGroupDto;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/workgroup/${encodeURIComponent($number)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: workGroupDto
    }));
}
export function deleteWorkGroup($number: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/workgroup/${encodeURIComponent($number)}`, {
        ...opts,
        method: "DELETE"
    });
}
export function deleteAllWorkGroups(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 409;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/workgroup/all", {
        ...opts,
        method: "DELETE"
    });
}
export function getWorkGroupXlsxTemplate(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/workgroup/template", {
        ...opts
    });
}
/**
 * Used to bulk import WorkGroups.
 */
export function importWorkGroups(baseWorkGroupDtoWorkGroupDtoImportDto: BaseWorkGroupDtoWorkGroupDtoImportDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ImportErrorDto[];
    } | {
        status: 202;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/workgroup/importall", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: baseWorkGroupDtoWorkGroupDtoImportDto
    }));
}
export function getWorkGroupListForImport(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: BaseWorkGroupDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/workgroup/importlist", {
        ...opts
    });
}
